import * as types from '../types'

const initialState = {
    statement: [],
    statementLoading: false,
    error: null
}

export const statementReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.GET_MY_STATEMENT:
            return {
                ...state,
                statement: action.payload,
                statementLoading: false,
                error: null
            }

        case types.SET_STATEMENT_LOADING:
            return {
                ...state,
                statementLoading: true,
                error:null
            }
        case types.RESET_LOADING:
            return {
                ...state,
                statementLoading: true,
                error:null
            }
        case types.RESET_STATEMENT:
            return {
                ...state,
                statement: [],
                statementLoading: false,
                error: null
            }
        case types.RESET:
            return {
                ...state,
                statementLoading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                statementLoading: false
            }
        default:
            return state
    }
}